const actions = {
    AUTH_SET_USER: (state, {user}) => ({
        ...state,
        user,
    }),
};

const reducer = (state = {}, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
